import axionIns from "../axios";

const getEarning = async () => {
    return axionIns.get("user/walletbalance").then((response) => { return response.data; });
};

const getRankingList = async (page, limit) => {
    return axionIns.get(`user/ranking?page=${page}&perPage=${limit}`).then((response) => { return response.data; });
};

const getPayoutsList = async (page, limit, status) => {
    return axionIns.get(`user/payouts?page=${page}&perPage=${limit}&status=${status}`).then((response) => { return response.data; });
};
const getAdvisorMertrix = async () => {
    return axionIns.get(`user/rankingsummary`).then((response) => { return response.data; });
};

const validateInput = async (payload) => {
    return axionIns.get(`user/ai${payload}`).then((response) => { return response.data; });
};

export default {
    getEarning,
    getRankingList,
    getPayoutsList,
    getAdvisorMertrix,
    validateInput
}
